<template>
  <div class="is-relative font-body-l">

    <div class="is-relative" id="meet-jen-ben">
      <o-meet-jen-ben
          :selected="womanSelected ? 'woman' : 'man'"
          v-on:select-face="handleFaceSelected"
      />
      <o-arrow-down-scroll
          :high="false"
          :mirror="manSelected"
          :active="womanSelected ? 'left': 'right'"
          :text="$tc('page.whatIsLiffery.new2023.arrows.2ndA')"
          :text2="$tc('page.whatIsLiffery.new2023.arrows.2ndB')"
          text-position="both"
          v-on:click="handleArrowSideSelected"
      />
    </div>

    <div class="is-relative" id="solo-artist">
      <o-how-people-use-liffery-solo :type="womanSelected? 'woman' : 'man'"/>
      <o-arrow-down-scroll
          :high="false"
          :mirror="true"
          text="Consider"
          title="$tc('page.whatIsLiffery.new2023.arrows.5th')"
          :text-position="'right'"
          v-on:click="handleScrollNext('the-family')"
      />
    </div>

    <div class="is-relative" id="the-family">
      <o-how-people-use-liffery-family/>
      <o-arrow-down-scroll
          :high="false"
          :mirror="false"
          text="Places"
          :title="$tc('page.whatIsLiffery.new2023.arrows.4th')"
          :text-position="'right'"
          v-on:click="handleScrollNext('the-friends')"
      />
    </div>

    <div class="is-relative" id="the-friends">
      <o-how-people-use-liffery-friends :load-map="true"/>
      <o-arrow-down-scroll
          :high="false"
          :mirror="true"
          :text="$tc('page.whatIsLiffery.new2023.arrows.3rd')"
          text-position="right"
          v-on:click="handleScrollNext('the-couples')"
      />
    </div>

    <div class="is-relative" id="the-couples">
      <o-how-people-use-liffery-couples/>
    </div>

    <div class="is-relative">
      <o-how-people-use-liffery-arrows-to-liffery/>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import OHowPeopleUseLifferySolo from '@/components/organisms/landing/sections/OHowPeopleUseLifferySolo.vue';
import OHowPeopleUseLifferyCouples from '@/components/organisms/landing/sections/OHowPeopleUseLifferyCouples.vue';
import OHowPeopleUseLifferyFriends from '@/components/organisms/landing/sections/OHowPeopleUseLifferyFriends.vue';
import OHowPeopleUseLifferyFamily from '@/components/organisms/landing/sections/OHowPeopleUseLifferyFamily.vue';
import OHowPeopleUseLifferyArrowsToLiffery
  from '@/components/organisms/landing/sections/OHowPeopleUseLifferyArrowsToLiffery.vue';
import AScrollDownArrow from '@/storybook-components/src/stories/atoms/AScrollDownArrow.vue';
import OArrowDownScroll from '@/components/organisms/landing/sections/OArrowDownScroll.vue';
import AScrollIntoViewport from '@/storybook-components/src/stories/atoms/AScrollIntoViewport.vue';
import OMeetJenBen from '@/components/organisms/landing/sections/OMeetJenBen.vue';

@Component({
  components: {
    OMeetJenBen,
    AScrollIntoViewport,
    OArrowDownScroll,
    AScrollDownArrow,
    OHowPeopleUseLifferyArrowsToLiffery,
    OHowPeopleUseLifferyFamily,
    OHowPeopleUseLifferyFriends,
    OHowPeopleUseLifferyCouples,
    OHowPeopleUseLifferySolo
  }
})
export default class OHowPeopleUseLiffery extends Vue {
  loadMap = true;
  womanSelected = true;
  manSelected = false;

  handleFaceSelected (input: {
    womanSelected: boolean,
    manSelected: boolean
  }) {
    this.womanSelected = input.womanSelected;
    this.manSelected = input.manSelected;
  }

  handleArrowSideSelected (input: 'left' | 'right') {
    if(input === 'left'){
      this.womanSelected = true;
      this.manSelected = false;
    } else {
      this.womanSelected = false;
      this.manSelected = true;
    }
  }

  handleScrollNext (id: string) {
    const el = document.getElementById(id) as HTMLElement;
    el.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
</script>
